export const highchartsOptions = {
    global: {
        useUTC: true,
    },
    lang: {
        weekdays: ['Ne', 'Po', 'Út', 'St', 'Čt', 'Pá', 'So'],
        months: [
            'leden',
            'únor',
            'březen',
            'duben',
            'květen',
            'červen',
            'červenec',
            'srpen',
            'září',
            'říjen',
            'listopad',
            'prosinec',
        ],
        shortMonths: [
            'led',
            'úno',
            'bře',
            'dub',
            'kvě',
            'čer',
            'čvc',
            'srp',
            'zář',
            'říj',
            'lis',
            'pro',
        ],
        decimalPoint: ',',
        rangeSelectorFrom: 'Od:',
        rangeSelectorTo: 'do:',
        rangeSelectorZoom: 'Zobrazit:',
    },
    chart: {
        style: {
            fontFamily: 'inherit',
            fontSize: '15px',
        },
        plotBorderColor: '#606063',
        animation: false,
    },
    title: {
        style: {
            color: '#E0E0E3',
            textTransform: 'uppercase',
            fontSize: '20px',
        },
    },
    subtitle: {
        style: {
            color: '#E0E0E3',
            textTransform: 'uppercase',
        },
    },
    tooltip: {
        backgroundColor: 'rgba(0, 0, 0, 0.85)',
        style: {
            color: '#F0F0F0',
        },
    },
    credits: {
        enabled: false,
    },
    labels: {
        style: {
            color: '#707073',
        },
    },

    // special colors for some of the
    legendBackgroundColor: 'rgba(0, 0, 0, 0.5)',
    background2: '#505053',
    dataLabelsColor: '#B0B0B3',
    textColor: '#C0C0C0',
    contrastTextColor: '#F0F0F3',
    maskColor: 'rgba(255,255,255,0.3)',
}

// Apply the theme
